<style>
  .autocomplete-container {
    position: relative;
    width: 300px;
  }

  input {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
  }

  .suggestions-list {
    list-style: none;
    margin: 0;
    padding: 0;
    border: 1px solid #ccc;
    max-height: 150px;
    overflow-y: auto;
    position: absolute;
    width: 100%;
    background: white;
    z-index: 10;
  }

  .suggestions-list li {
    padding: 8px;
    cursor: pointer;
  }

  .suggestions-list li.active {
    background-color: #ddd;
  }

  .tags-container {
    margin-top: 8px;
  }

  .tag {
    display: inline-block;
    background-color: #007bff;
    color: white;
    padding: 2px 0px 2px 8px;
    margin: 2px;
    border-radius: 4px;
  }

  .tag button {
    background: none;
    border: none;
    color: white;
    margin-left: 4px;
    cursor: pointer;
  }
</style>

<div class="floating-label-container">
  <div class="autocomplete-container">
    <div
      style="
        position: relative;
        align-items: center;
        border: 1px solid #dddddd;
        background-color: #ffffff;
        border-radius: 4px;
        padding: 5px;
      "
    >
      <input
        class="floatText"
        type="text"
        [value]="currentInput"
        (input)="onInput($event)"
        (keydown.enter)="addTag()"
        (blur)="handle_onBlur($event)"
        placeholder="Start typing..."
      />
      <label for="textbox" class="tb-validation-msg" [hidden]="isValid">{{
        validationMsg
      }}</label>
    </div>
    <div class="floatLabel">{{ label }}</div>
    @if (helpText != '') {
      <div
        class="helpOverlay"
        style="visibility: visible"
        (mouseover)="showHelp($event)"
      >
        ?
      </div>
    }
    @if (helpVisible && helpText != '') {
      <div
        id="{{ myId }}_h"
        (mouseout)="hideHelp($event)"
        (click)="$event.stopPropagation()"
        class="contextHelpBox"
      >
        {{ helpText }}
      </div>
    }

    @if (filteredSuggestions.length) {
      <ul class="suggestions-list">
        @for (
          suggestion of filteredSuggestions;
          track suggestion;
          let i = $index
        ) {
          <li
            [class.active]="i === activeIndex"
            (mousedown)="selectSuggestion(suggestion)"
          >
            {{ suggestion.name }}
          </li>
        }
      </ul>
    }
    <div class="tags-container">
      @for (tag of selectedTags; track tag) {
        <span class="tag">
          {{ tag.name }}
          <button (click)="removeTag(tag.name)">x</button>
        </span>
      }
    </div>
  </div>
</div>
